import React from "react"
import { Redirect } from "react-router-dom"

import { SsoMode } from "@cirrus/common/CustomerInfo"

import { LoginWithKeycodeScreenContent } from "./ScreenContent"
import { useCustomerInfo } from "../../../CustomerInfo"

export const LoginWithKeycodeProtectedScreenContent = () => {
  const { data } = useCustomerInfo()
  const allowed = data?.saml?.ssoMode !== SsoMode.Enforced && data?.keycode

  return allowed ? <LoginWithKeycodeScreenContent/> : <Redirect to="/"/>
}
